module.exports = __webpack_public_path__ + "img/C30C0C_9F0404_830404_5C0404-256px.25a0c6f6.png";